// extracted by mini-css-extract-plugin
export default {"salesCollectionHeader":"salesVsCollectionBarChart_salesCollectionHeader__U93q4"};